<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2">
                                <customer-sidebar v-if="currentUser.role == 'player'"></customer-sidebar>
                                <vendor-sidebar v-else></vendor-sidebar>
                            </div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Notifications</h2>
                        </div>
                        <div v-if="notifications.length > 0" class="pb-5 pt-3">
                            <div class="text-right mb-2">
                                <span class="text-sm text-muted mr-3">{{ unread_notifications.length }} notification(s) non lue(s)</span>
                                <button class="btn btn-sm btn-outline-secondary" @click="markAllAsRead()">Tout marquer comme lu</button>
                            </div>
                            <div v-for="notification in paginatedData" class="p-2 mb-2 rounded-lg">
                                <p class="text-sm" :class="{'font-weight-bolder': !notification.is_read}" style="margin-bottom: 2px;">{{ notification.message }}</p>
                                <span class="text-muted text-xs d-inline-block notification-age">{{ getNotificationAge(notification.created_at) }}</span>
                            </div>
                            <!-- PAGINATION -->
                            <nav class="my-4 text-xs">
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                            <span class="material-symbols-outlined text-sm">arrow_back</span>
                                        </button>
                                    </li>
                                    <li class="page-item">
                                        <select class="page-link text-dark text-xs h-100" v-model="currentPage" @change="goToPage(Number(currentPage))">
                                            <option v-for="page in totalPages" :key="page" :value="page">
                                                Page {{ page }}
                                            </option>
                                        </select>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                        <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                            <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div v-else class="text-center py-5">
                            <span class="text-sm">Pas de notifications.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.notification-age::first-letter {
    text-transform: uppercase;
}
</style>
<script>
import moment from 'moment'
import { api } from "@/store";
import defaultLogoPath from '@/assets/img/photo.png'

import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";

// import 'moment/locale/fr'
// moment.locale('fr')

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        "vendor-sidebar": VendorSidebar,
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications : []
        },
        unread_notifications() {
            const notifications = this.$store.getters.notifications;
            return notifications && Array.isArray(notifications) ? notifications.filter(notification => !notification['is_read']) : []
        },
        totalPages() {
            const notifications = this.notifications;
            return Math.ceil((notifications && notifications.length > 0 ? notifications.length : 0) / this.perPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const notifications = this.notifications;
            this.displayedNotifications = notifications && notifications.length > 0 ? notifications.slice(start, start + this.perPage) : [];
            return this.displayedNotifications;
        }
    },
    data() {
        return {
            displayedNotifications: [],
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
        }
    },
    watch: {
        'displayedNotifications': function(newNotifications) {
            const unreadDisplayed = newNotifications.filter(n => !n.is_read);
            if (unreadDisplayed.length === 0) return;
            this.markAllAsRead(true);
        }
    },
    methods: {
        getNotificationAge(timestamp) {
            return moment(timestamp).fromNow() // Returns relative time in French
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        markAllAsRead(onlyDisplayed = false) {
            const notifsToMark = onlyDisplayed ? this.displayedNotifications : this.notifications;
            const displayedIds = notifsToMark && notifsToMark.length > 0 ? notifsToMark.map(n => n.id) : [];
            if (displayedIds.length === 0) return;
            setTimeout(() => {
                // You can put any logic here (API call, navigation, etc.)
                api.post('/notifications/mark-as-read', { ids: displayedIds })
                    .catch(error => {
                        console.error("Error marking notifications as read:", error);
                    });
            }, 2000)
        }
    }
}
</script>